/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var ChessPawnIcon = createIcon({
  name: 'ChessPawnIcon',
  height: 512,
  width: 320,
  svgPath: 'M264 448H56s60-42.743 60-176H84c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h40.209C95.721 210.56 76 181.588 76 148c0-46.392 37.608-84 84-84s84 37.608 84 84c0 33.588-19.721 62.56-48.209 76H236c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12h-32c0 133.257 60 176 60 176zm28 16H28c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h264c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default ChessPawnIcon;